// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"738daa35","453":"6acacfec"}[chunkId] + ".chunk.js";
};